export function formatCurrency(value: number, currency: string) {
  if (typeof value == "number" && typeof currency == "string") {
    try {
      const formatter = new Intl.NumberFormat(navigator.language, { style: "currency", currency: currency, currencyDisplay: "narrowSymbol" })
      return formatter.format(value)
    } catch (e) { }
  }
  return `${value} ${currency}`
}
